'use client'
import React, { useState, useEffect } from 'react'
import { useRouter } from 'next/navigation'
import { currencies } from '@constants/currencies'
import { getCookie, setCookie } from 'cookies-next'
import { MdCurrencyExchange } from 'react-icons/md'

const MobileCurrencyTab = ({ dictionary }) => {
    const router = useRouter()
    const [activeCurrency, setActiveCurrency] = useState('thb')

    useEffect(() => {
        const currencyType = getCookie('currency')
        if (currencyType) {
            setActiveCurrency(currencyType)
        }
    }, [])

    const handleSelect = (currencyValue) => {
        setCookie('currency', currencyValue)
        setActiveCurrency(currencyValue)
        router.refresh()
    }

    return (
        <div className='px-4 py-3 border-t-[1px] border-gray-200'>
            <div className='flex items-center gap-2 mb-2'>
                <MdCurrencyExchange className='text-maincolor' size={16} />
                <span className='text-maincolor text-sm font-semibold'>{dictionary?.currency}</span>
            </div>
            <div className='flex flex-row flex-wrap gap-2'>
                {currencies.map((curr) => (
                    <button
                        key={curr.value}
                        onClick={() => handleSelect(curr.value)}
                        className={`px-3 py-1.5 rounded-md text-sm font-semibold border-[1px] transition-colors
                            ${activeCurrency === curr.value
                                ? 'bg-maincolor text-light border-maincolor'
                                : 'bg-transparent text-maincolor border-maincolor hover:bg-maincolor hover:text-light'
                            }`}
                    >
                        {curr.value.toUpperCase()}
                    </button>
                ))}
            </div>
        </div>
    )
}

export default MobileCurrencyTab